import { Link } from 'react-router-dom';
import { cn } from '@/lib/cn';
import { useKycStatus } from '@shared/hooks/use-associate';

// Thin banner rendered above Associate content when KYC isn't VERIFIED.
// Stays dismissible-free on purpose — the associate shouldn't be able to
// hide the requirement until it's satisfied.
export function KycBanner() {
  const { data: status } = useKycStatus();
  if (!status || status.status === 'VERIFIED') return null;

  const tone =
    status.status === 'REJECTED'
      ? 'bg-red-50 text-red-800 border-red-200'
      : status.status === 'PENDING'
        ? 'bg-amber-50 text-amber-800 border-amber-200'
        : 'bg-brand-50 text-brand-800 border-brand-200';

  const body =
    status.status === 'NOT_SUBMITTED'
      ? 'Complete your KYC to start receiving assigned transactions.'
      : status.status === 'PENDING'
        ? 'Your KYC is under review. We\u2019ll notify you once approved.'
        : 'Your KYC was rejected. ' + (status.rejectionReason ?? '') + ' Please resubmit.';

  return (
    <div className={cn('border-b px-6 py-2 text-sm', tone)}>
      <div className="mx-auto flex max-w-6xl items-center justify-between gap-3">
        <span>{body}</span>
        {status.status !== 'PENDING' ? (
          <Link
            to="/associate/kyc"
            className="rounded-md bg-white/60 px-3 py-1 text-xs font-medium hover:bg-white"
          >
            {status.status === 'REJECTED' ? 'Resubmit KYC' : 'Submit KYC'}
          </Link>
        ) : null}
      </div>
    </div>
  );
}
